module.exports = __webpack_public_path__ + "img/icon_tmall.26bf7d10.png";